import React from 'react';
import {
  makeStyles,
  mergeClasses,
  Spinner,
  tokens,
} from '@fluentui/react-components';

const useLoadingStyles = makeStyles({
  root: {
    marginTop: tokens.spacingVerticalM,
  },
});

export const Loading: React.FC<{ loadingText: string }> = React.memo(({ loadingText }) => {
  const classes = useLoadingStyles();

  return (
    <div className={mergeClasses('inline-copilot-loading', classes.root)}>
      <Spinner label={loadingText} size="tiny" />
    </div>
  );
});
